import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * [구성정보/공통] 상단 장비 구분 바
   * @author kimjy
   * @param  {Object} managegroupId
   * @return {Object}  장비구분 별 장비 개수
   */
  getObjCountForObjdefine(params) {
    return axios.post(`${baseUrl}/config/get-obj-count-for-objdefine.do`, params);
  },
  /**
   * [구성정보/공통] 장비목록 테이블 조회
   * @author kimjy
   * @param  {Object} params managegroupId, objDefineIds
   * @return {Object}        선택된 그룹/장비타입에 따른 장비목록
   */
  getCommonConfigInfoDeviceList(params) {
    return axios.post(`${baseUrl}/config/get-common-config-info-device-list.do`, params);
  },
  /**
   * 필터링된 테이블의 엑셀 출력 (2020. 02. 13)
   * @author Song
   */
  excelExportCommonConfigInfoDeviceList(params) {
    return axios.post(`${baseUrl}/config/excel-export-common-config-info-device-list.do`, params);
  },
  getObjTypeList(params) {
    return axios.post(`${baseUrl}/config/get-objtype-list.do`, params);
  },
  getMgrTreeInfoList(params) {
    return axios.post(`${baseUrl}/config/get-mgr-tree.do`, params);
  },
  getObjCompanyList(params) {
    return axios.post(`${baseUrl}/config/get-obj-company-list.do`, params);
  },
  getObjProductList(params) {
    return axios.get(`${baseUrl}/config/get-obj-product-list.do`, {
      params,
    });
  },
  getObjCompanyListHavingModel(params) {
    return axios.post(`${baseUrl}/config/get-obj-company-list-having-model.do`, {
      params,
    });
  },
  /**
   * 노드>구성현황
   * @author hyo
   * @param
   * @return
   */
  getBasicinfoSubList(params) {
    return axios.post(`${baseUrl}/config/get-basicinfosub-list-by-config.do`, params);
  },

  /**
   * [getChangeHistList 성능/운영 > 구성관리 > 변경이력 정보를 조회한다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getChangeHistList(params) {
    return axios.post(`${baseUrl}/config/get-change-hist-list.do`, params);
  },
  /**
   * [getDetailChangeHistList 성능/운영 > 구성관리 > 변경이력 상세정보를 조회한다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getDetailChangeHistList(params) {
    return axios.post(`${baseUrl}/config/get-detail-change-hist-list.do`, params);
  },
  /**
   * [exportChangeHistList 성능/운영 > 변경이력 정보를 엑셀 출력한다.] - 필터링된 데이터만 엑셀출력 가능하도록 수정
   * @author yelim -> NaJY
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  exportChangeHistList(params) {
    return axios.post(`${baseUrl}/config/export-change-hist-list.do`, params);
  },
  /**
   * [exportDetailChangeHistList 성능/운영 > 변경이력 상세 정보를 엑셀 출력한다.] - 필터링된 데이터만 엑셀출력 가능하도록 수정
   * @author yelim -> NaJY
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  exportDetailChangeHistList(params) {
    return axios.post(`${baseUrl}/config/export-detail-change-hist-list.do`, params);
  },
  getMgrInfoList() {
    return axios.get(`${baseUrl}/config/get-mgr-info-list.do`);
  },
  /**
   * 관리대상 구성 정보를 그룹 저장한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  applyObjGroupConfig(params) {
    return axios.post(`${baseUrl}/config/apply-obj-group-config.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/config/common.js